import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-solid",
  "use": "icon-arrow-solid-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 12\" id=\"icon-arrow-solid\"><path fill=\"#12161F\" d=\"M6 10.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z\" /><path fill=\"#fff\" d=\"M5.854 4.146a.5.5 0 1 0-.708.708l.708-.708ZM7 6l.354.354a.5.5 0 0 0 0-.708L7 6ZM5.146 7.146a.5.5 0 1 0 .708.708l-.708-.708Zm0-2.292 1.5 1.5.708-.708-1.5-1.5-.708.708Zm1.5.792-1.5 1.5.708.708 1.5-1.5-.708-.708Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol